import axios from "axios";

const CONFIGURED = process.env.REACT_APP_BACKEND_URL;

// Prefer the SAME origin the page is served from when it shares the backend's
// registrable domain (handles www vs non-www). This avoids cross-origin/CORS
// entirely in production, where the page may be opened on either host.
function resolveApiBase() {
  if (typeof window !== "undefined" && CONFIGURED) {
    try {
      const cfg = new URL(CONFIGURED);
      const here = window.location;
      const strip = (h) => h.replace(/^www\./, "");
      if (strip(cfg.hostname) === strip(here.hostname)) {
        return `${here.origin}/api`;
      }
    } catch (e) {
      /* fall through to configured */
    }
  }
  return `${CONFIGURED}/api`;
}

export const API = resolveApiBase();

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 20000,
});

// Retry transient failures (network drops, timeouts, 5xx) with exponential backoff.
// This prevents flaky mobile connections from breaking the whole page.
async function requestWithRetry(config, retries = 3, backoff = 700) {
  try {
    return await api.request(config);
  } catch (err) {
    const status = err.response?.status;
    const retriable =
      !err.response || err.code === "ECONNABORTED" || (status >= 500 && status < 600);
    if (retries > 0 && retriable) {
      await new Promise((r) => setTimeout(r, backoff));
      return requestWithRetry(config, retries - 1, backoff * 2);
    }
    throw err;
  }
}

export function apiGet(url, config = {}) {
  return requestWithRetry({ method: "get", url, ...config });
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
